<template>
    <ion-page>
        <standard-header title="Picks" align="middle"/>
        <ion-content :fullscreen="true" v-if="shipment.id">
            <pull-down-refresh :callback="refresh"/>
            <sub-title :count="shipment.lines.length">
                {{ shipment.reference }}
                <br /><small>{{ method }}</small>
            </sub-title>
            <ion-list>
                <ion-item v-if="shipment.lines.length <1" button detail @click="$router.replace({ name: 'picks.mine', direction: 'back'})">
                    <ion-label>No more lines to pick on this shipment</ion-label>
                </ion-item>
                <ion-item v-for="line in lines" :key="line.id" button detail @click="pick(line)">
                    <ion-icon :icon="checkmarkCircleOutline" color="success" v-if="line.is_picked" />
                    <ion-label class="ion-margin-start">
                        <h2>{{ line.item.name }}</h2>
                        <h3>{{ line.item.item_number }} @{{ line.location.code }}</h3>
                    </ion-label>
                </ion-item>
            </ion-list>
        </ion-content>
    </ion-page>
</template>

<script>
import PullDownRefresh from "@/components/PullDownRefresh";
import SubTitle from "@/components/SubTitle";

import _ from 'lodash';
import {IonContent, IonItem, IonLabel, IonList, IonPage, IonIcon} from '@ionic/vue';
import {modalController} from '@ionic/vue';
import StandardHeader from "@/components/StandardHeader";
import EventBus from "@/EventBus";
import PickLine from "@/views/modules/picking/pages/pick/PickLine";
import LocationSorter from "@/services/LocationSorter";
import {checkmarkCircleOutline} from 'ionicons/icons';
export default {
    name: "ListItems",
    inject: ['$http', '$toast'],
    components: {
        StandardHeader,
        SubTitle, PullDownRefresh, IonContent, IonItem, IonLabel, IonList, IonPage, IonIcon
    },
    mounted() {
        this.refresh();
    },
    computed: {
        params() {
            return this.$route.params;
        },
        method() {
            if (this.shipment.method.toUpperCase() === 'UPS') {
                return 'Boxes';
            }
            return 'Pallets';
        },
        lines() {
            return LocationSorter.sortByLocationCodes(
                _.filter(this.shipment.lines, line => {
                    return !line.is_parent;
                })
            );
        }
    },
    methods: {
        /**
         * Open the picker dialog in a modal - this way, we can pass
         * the entire line (already loaded) in as a prop.
         * @param line
         */
        pick(line) {
            modalController.create({
                component: PickLine,
                componentProps: {
                    line: line
                }
            }).then(modal => {
                modal.present();
                // if the onDidDismiss promise comes back with
                // something truish, then refresh the list
                modal.onDidDismiss()
                    .then(response => {
                        if (response.data) {
                            this.$toast.success("Pick saved");
                            this.refresh();
                        }
                    });
            });
        },
        refresh(event = null) {
            EventBus().emitter.emit('loading', true);
            this.$http.get(`/api/picks/me/shipments/${this.params.id}`, {
                params: {include: 'pickers,lines,lines.item,lines.item.locations,lines.item.locations,lines.item.locations.pivot,lines.item.image_urls,lines.sku,lines.sku.item,lines.sku.image_urls,lines.location,lines.location.zone,lines.item.mpns,lines.item.skus'}
            }).then(response => {
                this.shipment = response.data;
            }).finally(() => {
                if (event && event.target.complete) {
                    event.target.complete();
                }
                EventBus().emitter.emit('loading', false);
            });
        }
    },
    data() {
        return {
            shipment: {}
        }
    },
    setup() {
        return {
            checkmarkCircleOutline
        };
    }
}
</script>

<style scoped>
    >>> ion-title {
        line-height: 0.8em;
    }
</style>
